// extracted by mini-css-extract-plugin
module.exports = {"PaperSection":"Papers_PaperSection__36ONg","Papers":"Papers_Papers__3f0b-"};